import { IBookAChat, IBookAMeeting } from '@app-types/websocket/expert.types';

import { createAction } from 'redux-act';

export const bookMeeting = createAction<IBookAMeeting>('Book a meeting');
export const bookChat = createAction<IBookAChat>('book a chat');




// WEBPACK FOOTER //
// ./src/services/expert/expert.action.ts